import { BadgeVariant } from "../components/ui/StatusBadge";
import { ClinicExportJob, ClinicExportJobStatus } from "../services/settings.service";

export function statusToBadgeVariant(status: ClinicExportJobStatus): BadgeVariant {
  switch (status) {
    case "pending":
    case "running":
      return "running";
    case "completed":
      return "ready";
    case "failed":
      return "failed";
    case "cancelled":
      return "cancelled";
    default:
      return "cancelled";
  }
}

export function scopeLabel(includeDocuments: boolean): string {
  return includeDocuments ? "All records + documents" : "All records, no documents";
}

export function formatBytes(bytes: number | null | undefined): string {
  if (!bytes) return "—";
  const units = ["B", "KB", "MB", "GB", "TB"];
  let value = bytes;
  let unitIndex = 0;
  while (value >= 1024 && unitIndex < units.length - 1) {
    value /= 1024;
    unitIndex += 1;
  }
  return `${value.toFixed(1)} ${units[unitIndex]}`;
}

export function formatDateTime(iso: string | null | undefined): string {
  if (!iso) return "—";
  return new Date(iso).toLocaleString("en-IN", {
    day: "numeric",
    month: "short",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
}

export function formatDuration(startIso: string | null, endIso: string | null): string {
  if (!startIso || !endIso) return "—";
  const totalSeconds = Math.max(
    0,
    Math.round((new Date(endIso).getTime() - new Date(startIso).getTime()) / 1000)
  );
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  if (minutes === 0) return `${seconds} s`;
  return `${minutes} min ${seconds.toString().padStart(2, "0")} s`;
}

export function formatTimeRemaining(expiresAtIso: string | null | undefined): string {
  if (!expiresAtIso) return "—";
  const diffMs = new Date(expiresAtIso).getTime() - Date.now();
  if (diffMs <= 0) return "expired";
  const hours = Math.floor(diffMs / (1000 * 60 * 60));
  const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
  return `${hours}h ${minutes}m`;
}

export function isExpired(expiresAtIso: string | null | undefined): boolean {
  if (!expiresAtIso) return false;
  return new Date(expiresAtIso).getTime() <= Date.now();
}

export function totalRows(job: ClinicExportJob): number {
  if (!job.row_count_manifest) return 0;
  return Object.values(job.row_count_manifest).reduce((sum, n) => sum + n, 0);
}

export function tableCount(job: ClinicExportJob): number {
  return job.row_count_manifest ? Object.keys(job.row_count_manifest).length : 0;
}
